import {
  Box,
  Typography,
  Container,
  Grid,
  IconButton,
  useTheme,
  Stack,
} from "@mui/material";
import {
  Facebook,
  Instagram,
  LinkedIn,
  Twitter,
  Email,
  // LocationOn,
} from "@mui/icons-material";
import { styled } from "@mui/material/styles";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

const SocialIcon = styled(IconButton)(({ theme }) => ({
  width: 48,
  height: 48,
  border: `1px solid ${theme.palette.divider}`,
  transition: "all 0.3s ease",
  "&:hover": {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    transform: "translateY(-3px)",
    boxShadow: `0 4px 12px ${theme.palette.primary.main}40`,
  },
}));

const fadeIn = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0 },
};

function ContactSection() {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <Box
      id="contact"
      sx={{
        py: { xs: 8, md: 12 },
        background: "#FFFFFF",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={2} alignItems="center">
          <Grid size={{ xs: 12, sm: 6 }}>
            <motion.div
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              variants={fadeIn}
              transition={{ duration: 0.6 }}
            >
              <Typography
                variant="h3"
                fontWeight="bold"
                gutterBottom
                sx={{
                  mb: 3,
                  color: "#323B4B",
                  display: "inline-block",
                }}
              >
                {t("contact.title")}
              </Typography>
              <Typography
                variant="h6"
                color="text.secondary"
                paragraph
                sx={{ mb: 4, fontSize: "1.25rem" }}
              >
                {t("contact.subtitle")}
              </Typography>

              <Box component="ul" sx={{ listStyle: "none", pl: 0, mb: 4 }}>
                {/* <motion.li
                  variants={fadeIn}
                  transition={{ delay: 0.5 }}
                  style={{ marginBottom: theme.spacing(3) }}
                >
                  <Box sx={{ display: "flex", alignItems: "flex-start" }}>
                    <LocationOn
                      color="primary"
                      sx={{ fontSize: 28, mt: 0.5, mr: 2 }}
                    />
                    <Box>
                      <Typography
                        variant="subtitle1"
                        fontWeight="bold"
                        gutterBottom
                      >
                        {t("contact.locationTitle")}
                      </Typography>
                      <Typography variant="body1" color="text.secondary">
                        Malioboro Junction Ruko B, Jl. Letjen Suprapto ,
                        Pringgokusuman, Gedong Tengen, Kota Yogyakarta, Daerah
                        Istimewa Yogyakarta, Indonesia
                      </Typography>
                    </Box>
                  </Box>
                </motion.li> */}

                <motion.li
                  variants={fadeIn}
                  transition={{ delay: 0.6 }}
                  style={{ marginBottom: theme.spacing(3) }}
                >
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Email color="primary" sx={{ fontSize: 28, mr: 2 }} />
                    <Box>
                      <Typography
                        variant="subtitle1"
                        fontWeight="bold"
                        gutterBottom
                      >
                        {t("contact.emailTitle")}
                      </Typography>
                      <Typography variant="body1" color="text.secondary">
                        support@joglo.ink
                      </Typography>
                    </Box>
                  </Box>
                </motion.li>

                {/* <motion.li
                  variants={fadeIn}
                  transition={{ delay: 0.3 }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Phone color="primary" sx={{ fontSize: 28, mr: 2 }} />
                    <Box>
                      <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                        Call Us
                      </Typography>
                      <Typography variant="body1" color="text.secondary">
                        +62 123 4567 8910
                      </Typography>
                    </Box>
                  </Box>
                </motion.li> */}
              </Box>

              <motion.div variants={fadeIn} transition={{ delay: 0.7 }}>
                <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                  {t("contact.socialTitle")}
                </Typography>
                <Stack direction="row" spacing={2}>
                  <SocialIcon aria-label="Facebook">
                    <Facebook />
                  </SocialIcon>
                  <SocialIcon aria-label="Instagram">
                    <Instagram />
                  </SocialIcon>
                  <SocialIcon aria-label="Twitter">
                    <Twitter />
                  </SocialIcon>
                  <SocialIcon aria-label="LinkedIn">
                    <LinkedIn />
                  </SocialIcon>
                </Stack>
              </motion.div>
            </motion.div>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}

export default ContactSection;
